import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
function lazyLoad(view) {
  return () => import(`@/module/dashboard/${view}/${view}.vue`)
}
export default [
  { path: '/', component: lazyLoad('home') },
  { path: '/privacyPolicy', component: lazyLoad('privacyPolicy') },
  { path: '/aboutus', component: lazyLoad('aboutus') },
  { path: '/aboutusp', component: lazyLoad('aboutusp') },
  { path: '/innerPage', component: lazyLoad('innerPage') },
  { path: '/contact-us', component: lazyLoad('contactUs') },
  { path: '/videoPage', component: lazyLoad('videoPage') },
  { path: '/insights', component: lazyLoad('insights') },
  { path: '/agencyEcer', component: lazyLoad('agencyEcer') },
  { path: '/agency', component: lazyLoad('agencyHrdf') },
  { path: '/agencyKbs', component: lazyLoad('agencyKbs') },
  { path: '/agencyKpt', component: lazyLoad('agencyKpt') },
  { path: '/agencyMara', component: lazyLoad('agencyMara') },
  { path: '/agencyMedac', component: lazyLoad('agencyMedac') },
  { path: '/agencyMotac', component: lazyLoad('agencyMotac') },
  { path: '/agencyNcia', component: lazyLoad('agencyNcia') },
  { path: '/indSF', component: lazyLoad('indSF') },
  { path: '/allCourseList', component: lazyLoad('allCourseList') },
  { path: '/allCourses', component: lazyLoad('allCourseList') },
  { path: '/insightsnew', component: lazyLoad('insightsnew') },
  { path: '/reportarcticle', component: lazyLoad('reportarcticle') },
  { path: '/indskills', component: lazyLoad('indskills') },
  { path: '/upskillinsights', component: lazyLoad('upskillinsights') },
  { path: '/upskillstatis', component: lazyLoad('upskillstatis') },
  { path: '/courseDetails', component: lazyLoad('courseDetails') },
  { path: '/courseList', component: lazyLoad('courseList') },
  { path: '/faq', component: lazyLoad('faq') },
  { path: '/eLearningCert', component: lazyLoad('eLearningCert') },
  { path: '/satellitePartner', component: lazyLoad('satellitePartner') },
  { path: '/courseProviderList', component: lazyLoad('courseProviderList') },
  { path: '/skillList', component: lazyLoad('skillList') },
  { path: '/archivedCourseList', component: lazyLoad('archivedCourseList') },
  { path: '/satelliteEventList', component: lazyLoad('satelliteEventList') },
  { path: '/enrolments', component: lazyLoad('enrolments') },
  { path: '/guidelines', component: lazyLoad('guidelines') },
]
